<adaa-data-table
    [titleHeader]="tableTitle()"
    [isLocalData]="true"
    [localData]="tableData"
    [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.INTP_COUNTRIES_VALUE_CONF_LIST"
    [enableAdd]="!isDisabled()"
    [enableEditAction]="!isDisabled()"
    [enableDeleteAction]="!isDisabled()"
    [enableExport]="false"
    (addNewClicked)="addNewClicked()"
    (actionClicked)="actionClicked($event)"
/>
